import React from 'react'
import { Buffer } from 'buffer';
import kingdomImg from '../assets/logo_kingdom_256px.png';
import { useEffect } from 'react';
import MsgUtils from './Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function HeaderExterno({regional,idEmpleado,titulo,setUsuario,actualizar,callback}) {
    const mostrarUserLogin = () => {
        var login = localStorage.getItem('info');
        if (login !== undefined && login !==null) {
            login = JSON.parse(login)
            var imagen = Buffer.from(login.FOTO);
            imagen = imagen.toString('base64');
            var src = 'data:image/jpg;base64,' + imagen;
            return (
                <div className="navbar-brand card flex-row bg-dark m-0 p-0 " >
                    <div className="dropdown dropstart">
                        <a className="btn btn-sm dropdown-toggle" role="button" id="MenuOptiones" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={src} width="40" height="40" className=" my-auto rounded-circle card-img-left" />
                        </a>
                        <ul className="dropdown-menu bg-secondary bg-gradient" aria-labelledby="MenuOptiones">
                            <li><a className="dropdown-item btn btn-sm" >Cambiar Usuario/Contraseña</a></li>
                            <li><a className="dropdown-item btn btn-sm" >Ver Perfil</a></li>
                        </ul>
                    </div>
                    <div className='ps-2 my-auto d-none d-sm-inline'>
                        <div className="nombreHeader">{login.NOMBREX}</div>
                        <div className='cargoHeader'>{login.CARGO}</div>
                    </div>
                </div>);
        }
    }
    
    useEffect(() => {
        fetch(`${server}/usuario/getUserExterno`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional,idEmpleado
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    setUsuario(data.ok);
                    localStorage.setItem('info',JSON.stringify(data.ok));
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }, [actualizar]);
    return (
        <div className="navbar navbar-dark bg-dark m-0 p-0">
            <div className="container-fluid ">
                <div className="navbar-brand card flex-row bg-dark m-0 p-0" >
                    <img src={kingdomImg} alt="" width="40" height="35" className="d-inline-block align-text-top card-img-left my-auto" />
                    <div className='ps-2 my-auto d-none d-sm-inline'>
                        <div className="cargoHeader ">Chicken's</div>
                        <div className='cargoHeader '>Kingdom</div>
                    </div>
                </div>
                {titulo !== '' &&
                    <div className='text-light fw-bold fs-6 text-uppercase'>{titulo}</div>}
                {mostrarUserLogin()}
            </div>
        </div>
    );
}

export default HeaderExterno
